export default {
  en: {
    salePerson: 'Sales Person',
    keyword: 'Keyword',
    newSalePerson: 'New Sales Person',
    fullName: 'Full Name',
    position: 'Position',
    phone: 'Phone',
    mobile: 'Mobile',
    fax: 'Fax',
    email: 'Email',
    signature: 'Signature',
    confirmRemoveSalePersonTitle: 'Confirm',
    confirmRemoveSalePersonMessage: 'Confirm to delete <strong>{name}</strong>?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    removeSalePersonSuccess: 'Remove sales person success'
  },
  th: {
    salePerson: 'พนักงานขาย',
    keyword: 'คำที่ต้องการค้นหา',
    newSalePerson: 'สร้างพนักงานขาย',
    fullName: 'ชื่อ-สกุล',
    position: 'ตำแหน่ง',
    phone: 'โทร.',
    mobile: 'มือถือ',
    fax: 'แฟกซ์',
    email: 'อีเมล',
    signature: 'ลายเซ็นต์',
    confirmRemoveSalePersonTitle: 'ยืนยัน',
    confirmRemoveSalePersonMessage: 'กรุณายืนยันการลบ <strong>{name}</strong>',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    removeSalePersonSuccess: 'ลบบุคคลส่งสำเร็จ'
  }
}
